import '../../css/table.css';
import React from 'react';
import Layout from '../Shared/Layout';
import {Container, Grid} from "@material-ui/core";
import styled from "styled-components";
import Markdown from "react-markdown";
import remarkGfm from 'remark-gfm';
import rehypeRaw from "rehype-raw";


const Wrapper = styled.div`
`;

export default function Imprint({lang, content}) {
    return (
        <Wrapper>
            <Container maxWidth="lg">
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={10}>
                        <Markdown remarkPlugins={[remarkGfm]}
                                  rehypePlugins={[rehypeRaw]}
                        >
                            {content}
                        </Markdown>
                    </Grid>
                </Grid>
            </Container>
        </Wrapper>
    )
}

Imprint.layout = page => <Layout children={page}/>;
